import { create } from "zustand";

interface IFollowsStore {
  follows: string[];
  setFollows: (follows: string[]) => void;
  setFollow: (userName: string) => void;
  setUnFollow: (userName: string) => void;
  checkFollowing: (userName: string) => boolean;
}

export const useFollowsStore = create<IFollowsStore>(
  (set, get) => ({
    follows: [],
    setFollows: (follows: string[]) => set(() => ({ follows })),
    setFollow: (userName: string) => set((state) => {
      if (!state.follows.includes(userName)) {
        return { follows: [...state.follows, userName] };
      }
      return state;
    }),
    setUnFollow: (userName: string) => set((state) => {
      if (state.follows.includes(userName)) {
        return { follows: state.follows.filter((name) => name !== userName) };
      }

      return state;
    }),
    checkFollowing: (userName: string) => get().follows.includes(userName),
  }),
);
